/**
 * @module Experience / Repdash - back to top directive
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Directive, Input, OnDestroy, OnInit } from '@angular/core';
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { APIError } from '@support/api/common/error.interface';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[tmoPdlError]',
})

/**
 * Directive for tracing the error for pdl
 */
export class PdlErrorDirective extends PDLBaseComponent implements OnInit, OnDestroy {
  /**
   * Input value for error object .
   */
  @Input() public errorMessage: APIError;
  /**
   * Input value for errorText
   */
  @Input() public errorText: string;

  /**
   * Input value for form Name
   */
  @Input() public formName: string;

  /**
   * Input value for modal Name
   */
  @Input() public modalName: string;

  constructor(
    private route: ActivatedRoute,
    pdlService: PdlService
  ) {
    super(pdlService, route);
  }

  public ngOnInit(): void {
    super.ngOnInit();
    // this.pdlService.triggerCustomEvent(this.pdlPageComponentId, 'errorLoad');
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
